import React from 'react';

const DashboardOnHomePage = () => {
  return (
    <section className="bg-gradient-to-b from-white to-gray-100 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto flex flex-col-reverse lg:flex-row items-center justify-between space-y-8 lg:space-y-6 lg:space-x-16">
        
        {/* Left: Financial Writeups */}
        <div className="lg:w-1/2 animate-fadeInRight delay-300">
          <h2 className="text-3xl font-bold text-gray-900 mb-4 animate-fadeIn">Monitor Your Financial Growth</h2>
          <p className="text-lg text-gray-700 mb-6 leading-relaxed">
            Our advanced dashboard gives you real-time insights into your financial portfolio, helping you track profits,
            investments, and performance. Whether you're an individual investor or managing a team, you can easily
            assess trends and opportunities to optimize your strategies.
          </p>
          <ul className="space-y-4">
            <li className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-blue-500 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m-3-3H6" />
                </svg>
              </div>
              <div>
                <p className="text-gray-600">
                  Get detailed breakdowns of your financial activity, including transaction histories, profit margins, and balance updates.
                </p>
              </div>
            </li>
            <li className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-blue-500 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 3v18h18V3H3z" />
                </svg>
              </div>
              <div>
                <p className="text-gray-600">
                  Real-time data visualizations help you stay ahead by showing live metrics and KPIs across all your investments.
                </p>
              </div>
            </li>
            <li className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <svg className="h-6 w-6 text-blue-500 animate-pulse" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
                </svg>
              </div>
              <div>
                <p className="text-gray-600">
                  Keep track of daily, weekly, and monthly performance with detailed analytics that provide actionable insights.
                </p>
              </div>
            </li>
          </ul>
        </div>

        {/* Right: Image */}
        <div className="lg:w-1/2 flex justify-center lg:justify-end animate-fadeInLeft delay-500">
          <img
            src="https://i.ibb.co/J53NrmF/Screenshot-2025-01-15-093455.png"
            alt="Dashboard"
            className="w-full h-auto rounded-lg shadow-lg transition-transform transform hover:scale-105 duration-500 py-[5%]"
          />
        </div>
      </div>
    </section>
  );
};

export default DashboardOnHomePage;

